import { Component, OnInit, ViewChild, OnDestroy, Renderer2, AfterViewInit } from '@angular/core';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import swal from 'sweetalert2';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ReprogramarCobroComponent } from 'app/modals/cartera/reprogramar-cobro/reprogramar-cobro.component';
import { HistorialReprogComponent } from 'app/modals/cartera/historial-reprog/historial-reprog.component';
import { UpdateCobradorComponent } from 'app/modals/cartera/update-cobrador/update-cobrador.component';
import { AgendaService } from 'app/services/agenda-personal/agenda.service';
import { Empresa, Usuario } from 'app/entities/agenda';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { Cobradores, EstadoCobro } from 'app/entities/cobranza';
import { Title } from '@angular/platform-browser';
import { OrdenCobrosComponent } from 'app/modals/cartera/orden-cobros/orden-cobros.component';
import { HistoricoFacturasComponent } from 'app/modals/cartera/historico-facturas/historico-facturas.component';
import { UpdateObsCobroComponent } from 'app/modals/cartera/update-obs-cobro/update-obs-cobro.component';
import { HistorialCobrosComponent } from 'app/modals/cartera/historial-cobros/historial-cobros.component';
import { TesoreriaPrepagoComponent } from 'app/modals/cartera/tesoreria-prepago/tesoreria-prepago.component';
import { CambioEstadoCobroComponent } from 'app/modals/cartera/cambio-estado-cobro/cambio-estado-cobro.component';
import { AddNumeroFacturaComponent } from 'app/modals/cartera/add-numero-factura/add-numero-factura.component';
import { FormGroup, FormControl } from '@angular/forms';
import { ObservacionCarteraGrupoComponent } from 'app/modals/cartera/observacion-cartera-grupo/observacion-cartera-grupo.component';
import { LlamadasComponent } from 'app/modals/cartera/llamadas/llamadas.component';
import { SmsProgramarCobroComponent } from 'app/modals/cartera/sms-programar-cobro/sms-programar-cobro.component';
import { BeneficiariosXGrupoComponent } from 'app/modals/cartera/beneficiarios-x-grupo/beneficiarios-x-grupo.component';

@Component({
  selector: 'app-ver-cobros-cartera',
  templateUrl: './ver-cobros-cartera.component.html',
  styleUrls: ['./ver-cobros-cartera.component.scss']
})
export class VerCobrosCarteraComponent implements OnInit, OnDestroy, AfterViewInit {

  // Variables DataTable //
  public dtOptions: any;
  public tableOpt = [];
  @ViewChild(DataTableDirective, {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void> = new Subject();

  public empresas: Array<Empresa> = [];
  public cobradores: Array<Cobradores> = [];
  public estadoCobros: Array<EstadoCobro> = [];
  public agendadores: Array<Usuario> = [];
  newForm: FormGroup;
  public progress_bar: boolean;
  listenGlobal: Function;

  /**
   * Constructor
   *
   * @param {CarteraService} _cartera
   * @param {Renderer2} _renderer
   * @param {MatDialog} _dialog
   * @param {AgendaService} _agenda
   * @param {MatSnackBar} _snackBar
   * @param {Title} _title
   */
  constructor
  (
    private _cartera: CarteraService,
    private _renderer: Renderer2,
    private _dialog: MatDialog,
    private _agenda: AgendaService,
    private _snackBar: MatSnackBar,
    private _title: Title
  )
  {
    this.dtOptions = {
      responsive: {
        details: {
            type: 'column',
            target: -1
        }
      },
      autoWidth: false,
      order: [1, 'desc'],
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        },
        select: {
          rows: {
            _: "%d Filas seleccionadas",
            0: "Da clic en una fila para seleccionarla",
            1: "1 Fila seleccionada"
          }
        }
      },
      columns: [
        {
          title: '',
          orderable: false
        },
        {
          title: 'Or.',
          data: 'orden'
        },
        {
          title: 'Fecha',
          data: 'fecha'
        },
        {
          title: 'Jornada',
          data: 'jornada_hora'
        },
        {
          title: 'Empresa',
          data: 'empresa'
        },
        {
          title: 'Nombre',
          data: 'nombre_grupo'
        },
        {
          title: 'Radicado',
          data: 'radicado'
        },
        {
          title: 'Cobrador',
          data: 'cobrador'
        },
        {
          title: 'Actividad',
          data: 'actividad'
        },
        {
          title: 'Estado',
          render: (data, type, row, meta) => {
            return `<a style="color: ${data === 'Reprogramado' || data === 'Formato Visita' ? '#000000' : '#FFFFFF'}">${data}</a>`;
          }
        },
        {
          title: 'N°Factura',
          data: 'n_factura'
        },
        {
          title: 'N°Recibo',
          data: 'n_recibo'
        },
        {
          title: 'Valor',
          data: 'valor_cobro'
        },
        {
          title: 'Mes',
          data: 'mes_factura'
        },
        {
          title: 'Notas',
          data: 'notas',
          class: 'none'
        },
        {
          title: 'Ciclo',
          data: 'ciclo_grupo',
          class: 'none'
        },
        {
          title: 'Teléfonos',
          data: 'telefonos'
        },
        {
          title: 'Dirección Cobro',
          data: 'direccion_cobro',
          class: 'none'
        },
        {
          title: 'Dirección Alternativa',
          data: 'direccion_alternativa',
          class: 'none'
        },
        {
          title: 'Observación',
          data: 'obs_cobro',
          class: 'none'
        },
        {
          title: 'Abono a Pagar',
          data: 'MontoAbono',
          class: 'none'
        },
        {
          title: 'Abono Mes',
          data: 'Mes_FacturaAbono',
          class: 'none'
        },
        {
          title: 'N° Reprogramaciones',
          data: 'reprogramaciones'
        },
        {
          title: 'Reprogramación',
          data: 'reprogramacion'
        },
        {
          title: 'Reprogramación Fecha',
          data: 'fecha_reprog',
          class: 'none'
        },
        {
          title: 'Agendador',
          data: 'agendador',
          class: 'none'
        },
        {
          title: 'Reagendador',
          data: 'reagendador',
          class: 'none'
        },
        {
          title: 'Fecha Tesorería',
          data: 'fecha_tesoreria',
          class: 'none'
        },
        {
          title: 'Estado',
          data: 'active',
          class: 'none'
        },
        {
          title: 'Estado Factura',
          data: 'estado_factura',
          class: 'none'
        },
        {
          className: 'control',
          orderable: false,
          targets:   -1
        }
      ],
      dom: 'Blfrtip',
      buttons: [
        {
          extend: 'excel',
          title: function () { return `Cobros Agendados Entre ${moment($('#fecha_inicial').val()).format('DD-MM-YYYY')} Y ${moment($('#fecha_final').val()).format('DD-MM-YYYY')}`},
          text: 'Excel',
          filename: function () { return `cobros_${moment($('#fecha_inicial').val()).format('DD-MM-YYYY')}_${moment($('#fecha_final').val()).format('DD-MM-YYYY')}`}
        },
        {
          extend: 'pdf',
          text: 'PDF',
          orientation: 'landscape',
          pageSize: 'A2',
          filename: function () { return `cobros_${moment($('#fecha_inicial').val()).format('DD-MM-YYYY')}_${moment($('#fecha_final').val()).format('DD-MM-YYYY')}`},
          title: function () { return `Cobros Agendados Entre ${moment($('#fecha_inicial').val()).format('DD-MM-YYYY')} Y ${moment($('#fecha_final').val()).format('DD-MM-YYYY')}`}
        }
      ],
      select: true
    }
    this.dtTrigger.next();

    this.newForm = this.createForm();
    this._title.setTitle('VitalSoft - Agenda');
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this._agenda.VerEmpresas().subscribe((data: Array<Empresa>) => this.empresas = data);
    this._cartera.VerCobradores().subscribe((data: Array<any>) => {
      data.forEach((element, i) => {
        this.cobradores[i] = {
          codigo: element.documento_usuario,
          nombre: element.nombre_completo
        }
      });
    });
    this._cartera.VerEstadosCobro().subscribe((data: Array<EstadoCobro>) => this.estadoCobros = data);
    this._cartera.VerAgendadores().subscribe((data: Array<Usuario>) => this.agendadores = data);
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
    this.listenGlobal = this._renderer.listen('document', 'click', (e) => {
      if(e.target.hasAttribute('cobro')){
        this.modalReprogramacionCobro(e.target.getAttribute('cobro'));
      }else if(e.target.hasAttribute('hreprog')){
        this.modalHistorialReprogramacion(e.target.getAttribute('hreprog'));
      }else if(e.target.hasAttribute('cobrador')){
        this.modalUpdateCobrador(e.target.getAttribute('cobrador'));
      }else if(e.target.hasAttribute('orden')){
        this.modalAddOrden(e.target.getAttribute('orden'));
      }else if(e.target.hasAttribute('equivocacion')){
        this.toEquivocacion(e.target.getAttribute('equivocacion'));
      }else if(e.target.hasAttribute('observacion')){
        this.modalUpdateObsCobro(e.target.getAttribute('observacion'));
      }else if(e.target.hasAttribute('historial')){
        this.modalHistorialCobros(e.target.getAttribute('historial'));
      }else if(e.target.hasAttribute('factura')){
        this.modalAddFactura(e.target.getAttribute('factura'));
      }else if(e.target.hasAttribute('observaciones')){
        this.modalObservacionesGrupo(e.target.getAttribute('observaciones'));
      }else if(e.target.hasAttribute('grugru') && e.target.hasAttribute('grunit')){
        this.modalActiveBens(e.target.getAttribute('grunit'),e.target.getAttribute('grugru'),'rmv');
      }else if(e.target.hasAttribute('grugruVM') && e.target.hasAttribute('grunitVM')){
        this.modalActiveBens(e.target.getAttribute('grunitVM'),e.target.getAttribute('grugruVM'),'vm');
      }else if(e.target.hasAttribute('index')){
        this.openModalAlternativeDir(e.target.getAttribute('index'));
      }else{
        return;
      }
    });
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.listenGlobal();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Creación del FormGroup
   * @returns {FormGroup}
   */
  createForm(): FormGroup {
    return new FormGroup({
      origen: new FormControl('agenda'),
      fecha_inicio: new FormControl(moment()),
      fecha_final: new FormControl(moment()),
      empresa: new FormControl(),
      cobrador: new FormControl(),
      estado: new FormControl(),
      agendador: new FormControl(),
      ciclo: new FormControl()
    });
  }

  /**
   * Consulta los cobros según las especificaciones dadas
   * @param form
   */
  public cobrosCartera(form): void{
    // Aplicamos Formato Año-Mes-Dia(YYYY-MM-DD) a form.fecha_inicio y form.fecha_final
    form.fecha_inicio = moment(form.fecha_inicio).format('YYYY-MM-DD');
    form.fecha_final = moment(form.fecha_final).format('YYYY-MM-DD');

    // Barra de progreso
    this.progress_bar = true;

    this._cartera.verCarteraCobros(form).subscribe((data: any) => {
      this.renderer();
      this.tableOpt = data;
      this.progress_bar = false;
    });
  }

  /**
   * Renderiza la tabla
   */
  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Modals
  // -----------------------------------------------------------------------------------------------------

  /**
   * Abre el modal HistorialCobros
   * @param {number} index
   */
  public modalHistorialCobros(index: number): void{
    this._dialog.open(HistorialCobrosComponent, {
      maxWidth: '93vw',
      data: {
        grunit: this.tableOpt[index].documento,
        grugru: this.tableOpt[index].radicado,
      }
    });
  }

  /**
   * Abre el modal, TesoreriaPrepago, encargado de visualizar y modificar lo referente a prepago de un grupo,
   * este modal solo se abrira sí el estado del cobro es pagado(1) y el grupo es de ciclo 1
   * @param {number} index
   */
  public modalTesoreriaPrepago(index: number): void {
    this._dialog.open(TesoreriaPrepagoComponent, {
      width: '40%',
      data: {
        grunit: this.tableOpt[index].documento,
        grugru: this.tableOpt[index].radicado,
        nombre: this.tableOpt[index].nombre_grupo,
        database: this.tableOpt[index].empresa
      }
    });
  }

  /**
   * Abre modal CambioEstadoCobro
   * @param {number} index
   */
  public modalCambiarEstado(index: number): void {
    const ID_cobro: number = this.tableOpt[index].cobro;
    const Radicado: string = this.tableOpt[index].radicado;
    const Empresa: string = this.tableOpt[index].empresa === 'Vital Mascotas' ? '2' : '1';
    const EstadoCobro: string = this.tableOpt[index].EstadoCobro;
    const FechaCobro: string = this.tableOpt[index].fecha;

    let modal: any;

    modal = this._dialog.open(CambioEstadoCobroComponent, {
      data: {
        cobro: ID_cobro,
        grugru: Radicado,
        empresa: Empresa,
        estado_cobro: EstadoCobro,
        fecha: FechaCobro
      }
    });

    modal.afterClosed().subscribe((data: boolean) => {
      // Condición: si 'data' existe, ejecuta 'cobrosCartera'
      if(data) this.cobrosCartera(this.newForm.value);
    });
  }

  /**
   * Abre el modal Llamada, encargado de registrar una llamada al grupo anteriormente consultado,
   * al cerrarse y si devuelve una variable verdadera, ejecuta 'mostrarInfoGrupo'
   * @param {number} index
   */
  public modalLlamada(index: number): void{
    let modal;
    const Database: string = this.tableOpt[index].empresa === 'Vital Mascotas' ? 'medisoftvet' : 'medisoft';
    const Indice: string = this.tableOpt[index].empresa === 'Vital Mascotas' ? '2' : '1';
    const Hora: string = moment().format('HH:mm:ss');

    modal = this._dialog.open(LlamadasComponent, {
      width: '63%',
      height: '100%',
      panelClass: 'custom-dialog-container',
      data: {
        data_base: Database,
        indice: Indice,
        grunit: this.tableOpt[index].documento,
        grugru: this.tableOpt[index].radicado,
        grugru_asociado: this.tableOpt[index].radicado_asociado,
        hora: Hora,
        search_code: this.tableOpt[index].radicado,
        origen: 'agenda'
      }
    });
  }

  /**
   * esta funcion abre el modal de sms de programar cobros y
   * manda por parametros los datos (numero,telefono,radicado,grupo,factura) del radicado
   * mostrado en la tabla
   * @param {number} index
   */
  public smscobros(index: number):void {
    this._dialog.open(SmsProgramarCobroComponent,{
      width:'70%',
      data:{
        numero: this.tableOpt[index].celular_grupo,
        telefono: this.tableOpt[index].telefono_grupo,
        radicado: this.tableOpt[index].radicado,
        grupo: this.tableOpt[index].ID_Grupo,
        factura: this.tableOpt[index].factura_fisica,
        empresa:this.tableOpt[index].empresa
      }
    });
  }

  /**
   * Abre el modal AddNumeroFactura, encargado de añadir un número de factura al cobro,
   * solo si este tiene por estado Pago Factura No Generada(13),
   * sí al cerrarse devuelve una variable verdadera(TRUE) ejecuta 'cobrosCartera'
   * @param {number} index
   */
  public modalAddFactura(index: number): void {
    let modal: any;
    const ID_cobro: number  = this.tableOpt[index].cobro;

    modal = this._dialog.open(AddNumeroFacturaComponent, {
      data: {
        cobro: ID_cobro
      }
    });

    modal.afterClosed().subscribe((data: boolean) => {
      if(data) this.cobrosCartera(this.newForm.value);
    });
  }

  /**
   * Abre el modal ObservacionCarteraGrupo, encargado de visualizar y modificar las observaciones de cartera y contrato del grupo
   * @param {number} index
   */
  public modalObservacionesGrupo(index: number){
    const Database: string = this.tableOpt[index].empresa === 'Vital Mascotas' ? 'medisoftvet' : 'medisoft';
    this._dialog.open(ObservacionCarteraGrupoComponent, {
      width: '30%',
      height: '70%',
      data: {
        grunit: this.tableOpt[index].documento,
        grugru: this.tableOpt[index].radicado,
        base_datos: Database
      }
    });
  }

  /**
   * Abre el modal ReprogramarCobro, encargado de trasladar el cobro a otra fecha y modificar su cobrador,
   * al cerrarse y si devuelve una variable verdadera, ejecuta 'cobrosCartera'
   * @param {number} index
   */
  modalReprogramacionCobro(index: number): void {
    const ID_Grupo: string = this.tableOpt[index].ID_Grupo;
    const ID_cobro: string = this.tableOpt[index].cobro;
    const Radicado: string = this.tableOpt[index].radicado;
    const EstadoCobro: string =  this.tableOpt[index].EstadoCobro;
    const Empresa: string = this.tableOpt[index].empresa === 'Vital Mascotas' ? '2' : '1';

    let modal;

    modal = this._dialog.open(ReprogramarCobroComponent, {
      width: '40%',
      data: {
        ID_cobro: ID_cobro,
        ID_grupo: ID_Grupo,
        Radicado: Radicado,
        EstadoCobro: EstadoCobro,
        Empresa: Empresa
      }
    });

    modal.afterClosed().subscribe((result: boolean) => {
      // Condición: Si 'result' es verdadero, ejecuta 'cobrosCartera'
      if(result) this.cobrosCartera(this.newForm.value);
    });
  }

  /**
   * Abre el modal HistorialReprog, encargado de visualizar las reprogramaciones que ha tenido un cobro
   * @param {string} ID_cobro
   */
  modalHistorialReprogramacion(ID_cobro: string): void {
    this._dialog.open(HistorialReprogComponent, {
      data: {
        cobro: ID_cobro
      }
    });
  }

  /**
   * Abre el modal UpdateCobrador, encargado de actualizar el cobrador del cobro,
   * al cerrarse y si devuelve una variable verdadera, ejecuta 'cobrosCartera'
   * @param {string} index
   */
  modalUpdateCobrador(index: string): void{
    let modal: any;
    modal = this._dialog.open(UpdateCobradorComponent, {
      width: '25%',
      data: {
        ID_Cobrador: this.tableOpt[index].ID_Cobrador,
        FechaCobro: this.tableOpt[index].fecha,
        ID_Grupo: this.tableOpt[index].ID_Grupo,
        ID_Cobro: this.tableOpt[index].cobro,
        EstadoCobro: this.tableOpt[index].EstadoCobro
      }
    });
    modal.afterClosed().subscribe((data: boolean) => {
      // Condición: Si 'result' es verdadero, ejecuta 'cobrosCartera'
      if(data) this.cobrosCartera(this.newForm.value);
    });
  }

  /**
   * Abre modal FuseConfirmDialog, encargado de preguntarle al usuario sí desea realizar la acción,
   * sí al cerrarse devuelve una variable verdadera(TRUE), marcará el cobro como equivocación(5)
   * @param {number} index
   */
  toEquivocacion(index: number): void{
    let modal: any;
    const Cobro: number = this.tableOpt[index].cobro;
    const Bitacora_info = {
      antiguo_estado: this.tableOpt[index].EstadoCobro,
      nuevo_estado: '5',
      fecha_cobro: this.tableOpt[index].fecha,
      radicado: this.tableOpt[index].radicado,
      empresa: this.tableOpt[index].empresa === 'Vital Mascotas' ? '2' : '1',
      usuario: JSON.parse(localStorage.getItem('usuario'))['id_usuario']
    }

    modal = this._dialog.open(FuseConfirmDialogComponent, {
      data: {
        mensaje: '¿Marcar este cobro como equivocación?'
      }
    });

    modal.afterClosed().subscribe((result: boolean) => {
      // Condición: Si 'result' es verdadero, ejecuta el servicio 'EquivocacionCobro'
      if(result){
        this._cartera.EquivocacionCobro(Cobro, Bitacora_info).subscribe((data: any) => {
          // Condición: Si existen columnas afectadas, muestra mensaje de éxito y ejecuta 'cobrosCartera', de lo contrario, sale mensaje de error
          if(data['affectedRows'] > 0){
            this._snackBar.open('Cobro Eliminado ', 'Aceptar', {
              duration: 2000
            });
            this.cobrosCartera(this.newForm.value);
          }else{
            this._snackBar.open('Error al eliminar el cobro', '', {
              duration: 2500,
              panelClass: 'warn-500'
            });
          }
        });
      }
    });
  }

  /**
   * Abre el modal OrdenCobros, encargado de asignarle un orden a los cobros,
   * sí al cerrarse devuelve una variable, ejecuta el servicio 'OrdenCobro'
   * @param {number} index
   */
  modalAddOrden(index: number): void {
    const Cobro: string = this.tableOpt[index].cobro;
    const Orden: number = this.tableOpt[index].orden ;

    let modal: any;

    modal = this._dialog.open(OrdenCobrosComponent, {
      data: {
        orden: Orden
      }
    });

    modal.afterClosed().subscribe((data: {orden: number}) => {
      // Condición: Si devuelve una variable, ejecuta el servicio 'OrdenCobro'
      if(data.orden){
        this._cartera.OrdenCobro(Cobro, data).subscribe((data: any) => {
          // Condición: Si hay columnas afectadas, muestra mensaje de éxito y ejecuta 'cobrosCartera', de lo contrario, muestra mensaje de error
          if(data['affectedRows'] > 0){
            this._snackBar.open('Orden Agregado ', 'Aceptar', {
              duration: 2000
            });
            this.cobrosCartera(this.newForm.value);
          }else{
            this._snackBar.open('Error al agregar el orden', '', {
              duration: 2500,
              panelClass: 'warn-500'
            });
          }
        });
      }
    });
  }

  /**
   * Abre modal HistoricoFacturas, encargado de mostrar las facturas pertenecientes al grupo
   * @param {number} index
   */
  modalHistoricoFacturas(index: number): void {
    const Database: string = this.tableOpt[index].empresa === 'Vital Mascotas' ? 'medisoftvet' : 'medisoft';
    this._dialog.open(HistoricoFacturasComponent, {
      data: {
        grunit: this.tableOpt[index].documento,
        grugru: this.tableOpt[index].radicado,
        base_datos: Database
      }
    });
  }

  /**
   * Abre el modal UpdateObsCobro, encargado de visualizar y modificar la observación del cobro seleccionado,
   * sí al cerrarse devuelve una variable, ejecuta el servicio 'EditarObsCobro'
   * @param {number} index
   */
  modalUpdateObsCobro(index: number): void {

    const FechaCobro: string = this.tableOpt[index].fecha;
    const ID_Grupo: string = this.tableOpt[index].ID_Grupo;
    const ID_Cobro: string = this.tableOpt[index].cobro;
    let modal: any;

    modal = this._dialog.open(UpdateObsCobroComponent, {
      width: '30%',
      height: '65%',
      data: {
        observacion: this.tableOpt[index].obs_cobro
      }
    });

    modal.afterClosed().subscribe((data: string) => {
      // Condición: Si existe data, ejecuta 'EditarObsCobro'
      if(data){
        this._cartera.EditarObsCobro(FechaCobro, ID_Grupo, ID_Cobro, data).subscribe((data: any) => {
          // Condición: Si hay columnas afectadas, muestra mensaje de éxito y ejecuta 'cobrosCartera', de lo contrario, muestra mensaje de error
          if(data['affectedRows'] > 0){
            this._snackBar.open('Observación Actualizada', 'Aceptar', {
              duration: 2000
            });
            this.cobrosCartera(this.newForm.value);
          }else{
            this._snackBar.open('Error al actualizar la observación', '', {
              duration: 2500,
              panelClass: ['warn-600']
            });
          }
        });
      }
    });
  }
  modalActiveBens(grunit: string, grugru: string,empresa:string){
    this._dialog.open(BeneficiariosXGrupoComponent, {
      maxWidth: '93vw',
      data: {
        Documento: grunit,
        Radicado: grugru,
        empresa
      }
    });
  }

  async openModalAlternativeDir(index){
    let inputValue = this.tableOpt[index].direccion_alternativa;
    let id_cobro = this.tableOpt[index].cobro;
    let newAltDir = await swal.fire({
      type:'question',
      input:'text',
      showCancelButton:true,
      title:'Cuál es la nueva dirección alternativa que desea asignarle a este cobro?',
      inputValue
    });
    newAltDir.value
    if(!newAltDir.dismiss){
      this._cartera.setAltDir(newAltDir.value,id_cobro).subscribe(succ=>{
        swal.fire({
          type:'success',
          title:'Hecho',
          text:'Se actualizó correctamente la direccion'
        });
        this.tableOpt[index].direccion_alternativa = newAltDir.value;
        this.renderer();
      });
    }
  }
}
